import { isPlatformBrowser } from "@angular/common";
import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Optional,
    Output,
    PLATFORM_ID,
} from "@angular/core";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { ParamFilters } from "@app/models/filtermodels/ParamFilters";
import { HotelFiltersService } from "@app/services/hotelfilters.service";
import moment from "moment";
import { Subject, takeUntil } from "rxjs";
import { MEDIA_TOKEN } from "../../../../../../tockens";
import { MenuService } from "@app/services/menu.service";

@Component({
    selector: "clever-hotelfilter",
    templateUrl: "./hotelfilter.component.html",
    styleUrls: ["./hotelfilter.component.scss"],
    standalone: false,
})
export class HotelfilterComponent implements OnInit, OnDestroy {
    @Input() mode: string;
    @Input() israiltravel: boolean;
    @Input() type: string;
    @Input() reference: string;
    @Input() realparams: ParamFilters;
    @Input() completion: any;
    @Output() openLarge = new EventEmitter();
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    showMore: boolean = false;
    showSmallFilter: boolean = true;
    @Output() showSmallVersion = new EventEmitter();
    media: string = "lg";
    btntext: string = "URLAUB FINDEN";
    start: string;
    end: string;
    filter: ParamFilters;

    constructor(
        protected mediaObserver: BreakpointObserver,
        protected cdr: ChangeDetectorRef,
        protected hotelFilters: HotelFiltersService,
        protected menuService: MenuService,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Optional() @Inject(MEDIA_TOKEN) private media_token: string
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.media = this.media_token;
    }

    ngOnInit(): void {
        this.btntext = "URLAUB FINDEN";
        this.initFilters();
        this.initFilterSub();
        this.initMedia();
        if (this.isBrowser) {
            this.menuService.search
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((obj) => {
                    if (obj) {
                        this.openLargeFilter();
                    } else {
                        this.closeLargeFilter();
                    }
                });
        }
    }

    initMedia(): void {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = "xs";
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = "sm";
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = "md";
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = "lg";
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = "xl";
        }
        this.cdr.detectChanges();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    gotoZiel(gotourl): void {
        this.showSmallVersion.emit(true);
        this.hotelFilters.setIsReilTravel(this.type === "railtravel");
        this.hotelFilters.setReference(this.reference);
        if (gotourl) {
            this.hotelFilters.gotoUrl(this.type);
        } else {
            this.hotelFilters.changeUrlByType(this.type);
        }
    }

    initFilterSub(): void {
        this.hotelFilters.getfilters$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((filter: ParamFilters) => {
                this.filter = JSON.parse(JSON.stringify(filter));
                this.initDate(filter);
                this.cdr.detectChanges();
            });
    }

    async setBahn() {
        this.type = "railtravel";
        this.hotelFilters.onlySetProductType("railtravel");
    }

    async setPauschal() {
        this.type = "pauschal";
        this.hotelFilters.onlySetProductType("pauschal");
    }

    async setHotelonly() {
        this.type = "hotelonly";
        this.hotelFilters.onlySetProductType("hotelonly");
    }

    async initDate(filter) {
        const reg = new RegExp("^\\d+,\\d+,\\d+$");
        if (String(filter?.reisezeitraumResult).match(reg)) {
            const tmp = String(filter?.reisezeitraumResult).split(",");
            this.start = moment().add(tmp[0], "days").format("YYYY-MM-DD");
            this.end = moment()
                .add(Number(tmp[1]) + Number(tmp[0]), "days")
                .format("YYYY-MM-DD");
        } else if (filter?.reisezeitraumResult?.start?.length > 0) {
            if (
                moment(filter.reisezeitraumResult.start).format("YYYY-MM-DD") <
                moment().format("YYYY-MM-DD")
            ) {
                this.start = moment().add(4, "days").format("YYYY-MM-DD");
                this.end = moment().add(180, "days").format("YYYY-MM-DD");
            } else {
                this.start = moment(filter.reisezeitraumResult.start).format(
                    "YYYY-MM-DD"
                );
                this.end = moment(filter.reisezeitraumResult.end).format("YYYY-MM-DD");
            }
        } else if (!isNaN(Number(filter?.reisezeitraumResult?.start))) {
            this.start = moment()
                .add(Number(filter.reisezeitraumResult.start), "days")
                .format("YYYY-MM-DD");
            this.end = moment()
                .add(Number(filter.reisezeitraumResult.end), "days")
                .format("YYYY-MM-DD");
        } else {
            this.start = moment().add(4, "days").format("YYYY-MM-DD");
            this.end = moment().add(180, "days").format("YYYY-MM-DD");
        }
        this.cdr.detectChanges();
    }

    openLargeFilter(): void {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
        this.showSmallFilter = false;
        this.openLarge.emit(true);
        this.showSmallVersion.emit(this.showSmallFilter);
    }

    closeLargeFilter(): void {
        this.showSmallFilter = true;
        this.openLarge.emit(false);
        this.showSmallVersion.emit(this.showSmallFilter);
    }

    openclosemore(): void {
        this.showMore = !this.showMore;
    }

    initFilters(): void {
        if (this.realparams) {
            this.hotelFilters.onlySetRealParams(this.realparams);
        } else if (this.mode === "home") {
            this.hotelFilters.resetAllExtrasHome();
        }
    }

    async switchTo(productType) {
        this.hotelFilters.setProductType(productType);
    }

    selectValue(ev): void {
        this.hotelFilters.reisezeitraumResult(ev.start, ev.end);
    }

    async resTraveler(ev) {
        this.hotelFilters.reisendeResult(ev);
    }
}
